import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import * as Sentry from "@sentry/react";
import App from "./App.jsx";
import "./index.css";
import useThemeStore from "./store/themeStore.js";
import { captureSignupSource } from "./utils/signupSource";


// Initialize Sentry before React mounts so any error during initial
// render is captured. Skipped when DSN is empty (e.g. dev .env.local
// without the variable) and effectively silent in non-production
// environments where MODE !== "production".
if (import.meta.env.VITE_SENTRY_DSN) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    // The environment tag in Sentry's UI. Vite exposes MODE which
    // matches the npm script (development / production / preview).
    environment: import.meta.env.MODE,
    // Errors at 100% (always capture), traces sampled at 10% to keep
    // free-tier quota in check.
    tracesSampleRate: 0.1,
    integrations: [Sentry.browserTracingIntegration()],
    // Don't include user IPs or PII by default. Matches the
    // privacy-conscious posture set on the backend.
    sendDefaultPii: false,
  });
}

// Record the entry point before any routing happens, since document.referrer
// is only populated on the first page load of the session.
captureSignupSource();

useThemeStore.getState().init();

createRoot(document.getElementById("root")).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
